import { AbstractRequirementMapper } from '@/features/CompanyQuestions/RequirementMapping/AbstractRequirementMapper';

export class HundeAnzahl extends AbstractRequirementMapper {
  protected frontendKey = 'hundeAnzahl';

  public getValues(): number[] {
    return super.getValues().map((v) => Number(v));
  }
}
